/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content/SaveAction",
  onSubmit,
  disabled
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let settingsSubmitData = fromData.useDataSubmit({ viewPath,
context: 'settings',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<div
  data-testid="SaveAction.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z25i121': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 marginLeft="auto"
 marginTop={dtSpaceXs}
 marginRight={dtSpaceL}
 marginBottom={dtSpaceXs}
 data="settings"
 onClick={settingsSubmitData}
 disabled={disabled}
 text="Save"
/>
</div>
{children}
</React.Fragment>)
}